import {
  FiatChannelProvider,
  WalletsFiatChannelsClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletsFiatChannelsClient = new WalletsFiatChannelsClient(
  apiConfig,
  undefined,
  axiosInstance
);

export const handleGetPaymentProviders = async (): Promise<
  FiatChannelProvider[]
> => {
  const paymentProviders = (
    await walletsFiatChannelsClient.getFiatChannelProviders()
  ).data.records;
  return paymentProviders;
};
